export default "__VITE_ASSET__b4f9c987__"